export { default as en } from './en.json';
export { default as es } from './es.json';

export const NS = 'organization' as const;
